module.exports = __webpack_public_path__ + "img/share.4489ffb6.png";